import {createStore} from 'vuex'
import createLocalStoragePlugin from '@/store/plugins/localStoragePlugin'
import createLoggerPlugin from '@/store/plugins/loggerPlugin'
import settingsModule from '@/store/modules/settings'
import configModule from '@/store/modules/config'
import {merge} from 'lodash'
import betBuilderModule from '@/store/modules/betBuilder'
import voiceModule from '@/store/modules/voice'
import sessionModule from '@/store/modules/session'
import composeModule from '@/store/modules/compose'
import scopeModule from "@/store/modules/scope"
import oddsModule from '@/store/modules/odds'
import {bundleTemplateHistoryModule} from "@/store/modules/bundleTemplateHistory";
import {bundleTemplateSeenModule} from "@/store/modules/bundleTemplateSeen";

export const LOCAL_STORAGE_STORE = 'store'

const localStoragePlugin = createLocalStoragePlugin()
const loggerPlugin = createLoggerPlugin()

const store = createStore({
	state: {
		storeVersion: 2,
		context: '',
		contextFilter: '',
		isAdmin: false,
		isDev: false,

		isInfoModalOpen: false,
		isTranslateModalOpen: false,
		isSettingsModalOpen: false,
	},

	mutations: {
		initialiseStore(state: any) {
			if (localStorage.getItem(LOCAL_STORAGE_STORE)) {
				const localStorageState = JSON.parse(
						<string>localStorage.getItem(LOCAL_STORAGE_STORE),
				)

				// If there is a major breaking version change then obliterate the store and use the defaults.
				// Note: a major breaking version change is one that removes items from the store or moves items to a new module.
				// TODO: Set existing keys on current state.
				if (
						!localStorageState.storeVersion ||
						localStorageState.storeVersion < state.storeVersion
				) {
					localStorage.removeItem(LOCAL_STORAGE_STORE)
				} else {
					this.replaceState(merge(state, localStorageState))
				}
			}
		},

		setContext(state, context) {
			state.context = context
		},

		setContextFilter(state, contextFilter) {
			state.contextFilter = contextFilter
		},

		setIsAdmin(state, isAdmin) {
			state.isAdmin = isAdmin
		},

		setIsDev(state, isDev) {
			state.isDev = isDev
		},

		setIsInfoModalOpen(state, isInfoModalOpen) {
			state.isInfoModalOpen = isInfoModalOpen
		},

		setIsTranslateModalOpen(state, isTranslateModalOpen) {
			state.isTranslateModalOpen = isTranslateModalOpen
		},

		setIsSettingsModalOpen(state, isSettingsModalOpen) {
			state.isSettingsModalOpen = isSettingsModalOpen
		},
	},

	actions: {
		setContext({commit}, context) {
			commit('setContext', context)
		},

		setContextFilter({commit}, context) {
			commit('setContextFilter', context)
		},

		setIsAdmin({commit}, isAdmin) {
			commit('setIsAdmin', isAdmin)
		},

		setIsDev({commit}, isDev) {
			commit('setIsDev', isDev)
		},

		setIsInfoModalOpen({commit}, isInfoModalOpen) {
			commit('setIsInfoModalOpen', isInfoModalOpen)
		},

		setIsTranslateModalOpen({commit}, isTranslateModalOpen) {
			commit('setIsTranslateModalOpen', isTranslateModalOpen)
		},

		setIsSettingsModalOpen({commit}, isSettingsModalOpen) {
			commit('setIsSettingsModalOpen', isSettingsModalOpen)
		},
	},

	getters: {
		context(state) {
			return state.context
		},

		contextFilter(state) {
			return state.contextFilter
		},

		isAdmin(state) {
			return state.isAdmin
		},

		isDev(state) {
			return state.isDev
		},

		isInfoModalOpen(state) {
			return state.isInfoModalOpen
		},

		isTranslateModalOpen(state) {
			return state.isTranslateModalOpen
		},

		isSettingsModalOpen(state) {
			return state.isSettingsModalOpen
		},
	},

	modules: {
		configModule,
		settingsModule,
		betBuilderModule,
		voiceModule,
		scopeModule,
		sessionModule,
		composeModule,
		oddsModule,
		bundleTemplateHistoryModule,
		bundleTemplateSeenModule
	},

	plugins: [localStoragePlugin, loggerPlugin],
})

store.dispatch('oddsModule/fetchRegions')

export default store
